import { render, staticRenderFns } from "./ResourceAttachmentsList.vue?vue&type=template&id=4bc30784&scoped=true"
import script from "./ResourceAttachmentsList.vue?vue&type=script&lang=js"
export * from "./ResourceAttachmentsList.vue?vue&type=script&lang=js"
import style0 from "./ResourceAttachmentsList.vue?vue&type=style&index=0&id=4bc30784&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc30784",
  null
  
)

export default component.exports